import script from "./avatar.vue?vue&type=script&setup=true&lang=js"
export * from "./avatar.vue?vue&type=script&setup=true&lang=js"

import "./avatar.vue?vue&type=style&index=0&id=faf92d5e&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faf92d5e"]])

export default __exports__